import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";
import { UserListResponse, UserRequest } from "../../../schemas";

const GET = async (
  operationId: string,
  params: {
    limit?: number;
    offset?: number;
  },
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<UserListResponse>> => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value.toString());
  });
  const queryParams = searchParams.toString();
  const url = `/api/roles-svc/v2/operation/${operationId}/user${
    queryParams && "?" + queryParams
  }`;
  const response = await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const PUT = async (
  operationId: string,
  users: UserRequest[],
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  const response = await axios.put(
    `/api/roles-svc/v2/operation/${operationId}/user`,
    users,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  GET,
  PUT,
};
